var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-drawer',{attrs:{"title":"预览页面","placement":"right","closable":true,"visible":_vm.visible,"width":"450"},on:{"close":_vm.onClose}},[_c('div',{staticClass:"phone-box"},[_c('iframe',{attrs:{"name":"pageIframe","id":"pageIframe","frameborder":"0","width":"100%","height":"100%","src":(_vm.url + "?editing=true"),"allowFullScreen":"true"}})]),_c('div',{style:({
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: '100%',
      borderTop: '1px solid #394555',
      padding: '10px 16px',
      background: '#394555',
      textAlign: 'right',
      zIndex: 1,
    })},[_c('a-button',{style:({ marginRight: '8px' }),on:{"click":_vm.onClose}},[_vm._v("\n      取消\n    ")]),_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.handleRefreshPreview}},[_vm._v("\n      刷新页面\n    ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }